// src/pages/Page2/mixpanelConfig.ts
import { SDK, Analytics } from '@digitaltitransversal/tr_rnm_analytics';
import { MixPanelSDK } from '@digitaltitransversal/tr_mixpanel_web_sdk';

const MIXPANEL_TOKEN = process.env.NEXT_PUBLIC_APP_MIXPANEL_TOKEN || '';

let initialized = false;

export const initMixpanel = () => {
  if (initialized) return;

  if (!MIXPANEL_TOKEN) {
    console.error('Mixpanel token missing');
    return;
  }

  SDK.registerSDKs({
    MixPanel: new MixPanelSDK({
      token: MIXPANEL_TOKEN,
      options: {},
    }),
  });

  SDK.initSdk({ MixPanel: {} });
  console.log('Mixpanel initialized');

  initialized = true;
};

export const trackEvent = (eventName: string, params?: Record<string, any>) => {
  initMixpanel();
  Analytics.sendEvent({
    eventName,
    params,
  });
};
